<template>
  <div class="mobile-navigation-sub-companies-fi">
    <ul
      class="mobile-navigation-sub-companies-fi__list mobile-navigation-sub-companies-fi__list--services"
    >
      <li
        class="mobile-navigation-sub-companies-fi__item mobile-navigation-sub-companies-fi__item--group"
      >
        <a
          :href="groupData?.url"
          :target="groupData?.target"
          class="mobile-navigation-sub-companies-fi__item__wrapper"
        >
          <span class="mobile-navigation-sub-companies-fi__item__label">
            {{ navigationLayerTitle(groupData) }}
          </span>

          <arrow-icon class="mobile-navigation-sub-companies-fi__item__icon" />
        </a>
      </li>
      <li
        v-for="item in companiesHeaderLinks"
        :id="`fi-navigation-${item.CategoryId}`"
        :key="item.CateogryId"
        class="mobile-navigation-sub-companies-fi__item mobile-navigation-sub-companies-fi__item--page"
      >
        <a
          :href="groupData?.url + item.slug"
          :target="item.target ? item.target : null"
          class="mobile-navigation-sub-companies-fi__item__wrapper"
        >
          <span class="mobile-navigation-sub-companies-fi__item__label">
            {{ item.label }}
          </span>

          <arrow-icon class="mobile-navigation-sub-companies-fi__item__icon" />
        </a>
      </li>
    </ul>
    <ul class="mobile-navigation-sub-companies-fi__list">
      <li
        v-for="item in companiesLinks"
        :key="item.id"
        class="mobile-navigation-sub-companies-fi__item"
      >
        <a
          :href="item.url"
          :target="item.target ? item.target : null"
          class="mobile-navigation-sub-companies-fi__item__wrapper"
        >
          <cloud-image-fi
            :src="item.teaserImage?.src"
            :alt="item.label"
            class="mobile-navigation-sub-companies-fi__item__image"
          />

          <div class="mobile-navigation-sub-companies-fi__item__label fi-text-16 fi-semibold">
            <span class="fi-mr-9">
              {{ item.label }}
            </span>
            <arrow-icon class="navigation-companies-fi__arrow" />
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ArrowIcon, CloudImageFi } from 'atoms';
import { computed, ref } from 'vue';

import { useNavigation } from '@/composables/navigation';
import { useNavigationStore } from '@/store/pinia/navigation';

defineOptions({ name: 'MobileNavigationSubCompaniesFi' });

const navigationStore = useNavigationStore();
const { navigationLayerTitle } = useNavigation();

const companiesHeaderLinks = ref<any[]>([]);
const companiesLinks = ref<any[]>([]);

const groupData = computed(() => navigationStore.groupData);
const subElements = computed(() => navigationStore.subElements);

// created logic
subElements.value.forEach((element: any) => {
  if (element.isProxy) {
    companiesLinks.value.push(element);
  } else {
    companiesHeaderLinks.value.push(element);
  }
});
</script>

<style scoped src="./mobile-navigation-sub-companies-fi" />
